import React from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { Grid, InputLabel, TextField } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Link } from 'react-router-dom';


const BookingForm = () => {
    const [selectedDate, setSelectedDate] = React.useState(new Date('2020-09-18T21:11:54'));
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };
    return (
        <div>
            <InputLabel htmlFor="origin" style={{color:'black'}}>Origin</InputLabel>
            <TextField fullWidth id="origin" placeholder="Enter city name" />
            <br />
            <br />
            <InputLabel htmlFor="destination" style={{color:'black'}}>Destination</InputLabel>
            <TextField fullWidth id="destination" placeholder="Enter city name" />
            <br />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-between">
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        label="From"
                        value={selectedDate}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="To"
                        format="MM/dd/yyyy"
                        value={selectedDate}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </Grid>
            </MuiPickersUtilsProvider>
            <Link className="btn btn-primary mt-4" to="/hotel">Start Booking</Link>

            <div style={{height:'100px'}}></div>
        </div>
    );
};

export default BookingForm;